export default {
  pageTitle: {
    en: "Sign up to your account",
    ja: "アカウントにサインアップ"
  },

  buttonText: {
    en: "Sign up",
    ja: "サインアップ"
  },
  forgotPassword: {
    en: "Forgot password?",
    ja: "パスワードをお忘れですか？"
  },
  Code: {
    en: "One time code",
    ja: "ワンタイムコード"
  },
  cancel: {
    en: "Cancel",
    ja: "キャンセル"
  },
  alreadyRegistered: {
    en: "Already registered?",
    ja: "すでに登録？"
  },
  signIn: {
    en: "Sign in",
    ja: "ログイン"
  },

  codeText: {
    en: "A message with a verification code has been sent to your email. Enter the code to continue.",
    ja: "確認コードが記載されたメッセージがメールに送信されました。 コードを入力して続行します。"
  },

  emailAddressLabel: {
    en: "Email",
    ja: "電子メールアドレス"
  },
  passwordLabel: {
    en: "Password",
    ja: "パスワード"
  },
  confirmPasswordLabel: {
    en: "Confirm password",
    ja: "パスワードを認証する"
  },

  incorrectEmailWarning: {
    en: "Please enter a correct email",
    ja: "正しいメールアドレスを入力してください"
  },
  incorrectPasswordWarning: {
    en: "Password should be longer than 8 characters",
    ja: "パスワードは 8 文字以上にする必要があります"
  },
  passwordsNotMatchWarning: {
    en: "Passwords should match",
    ja: "パスワードは一致する必要があります"
  }
}
